import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '../../themes/defaultTheme';

export const useIsDesktop = (): boolean => {
  return useMediaQuery({ minWidth: breakpoints.sm });
};
